/* eslint-disable @typescript-eslint/indent */
import { AfterViewInit, Component, Input } from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import { Params } from "@angular/router";
import { MapBoxData } from "./map-box.type";

@Component({
  selector: "app-map-box",
  templateUrl: "./map-box.component.html",
  styleUrls: ["./map-box.component.scss"],
})
export class MapBoxComponent<T = unknown> implements AfterViewInit {
  @Input() config: MapBoxData<T>;

  ngAfterViewInit(): void {
    this.config.updateLocations();
  }

  onPaginationChange(event: PageEvent): void {
    const params: Params = {
      pagination: {
        pageSize: event.pageSize,
        page: event.pageIndex + 1,
      },
    };

    this.config.updateLocations(params);
  }
}
